module.exports = __webpack_public_path__ + "img/1.110c0cbc.png";